module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/fair-trade-high-growth-1200x630.b8431bd8.jpg";